<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const notifications = computed(() => store.state.notifications.notifications);
</script>

<template>
    <div v-if="notifications.length" class="fixed top-5 right-5 z-[5] max-w-[360px]">
        <v-alert
            v-for="notification in notifications"
            :key="notification.id"
            :type="notification.type"
            class="fade-alert"
            closable 
        >
            {{ 
				notification.message 
				?? notification.text 
				?? $t('notifications.general_error') 
            }}
        </v-alert>
  </div>
</template>

<style scoped>
@keyframes fadeInOut {
	0% {
		opacity: 0;
		transform: translateY(-20px);
	}
	10% {
		opacity: 1;
		transform: translateY(0);
	}
	90% {
		opacity: 1;
		transform: translateY(0);
	}
	100% {
		opacity: 0;
		transform: translateY(-20px);
	}
	}

.fade-alert {
  	animation: fadeInOut 4s ease-in-out forwards;
}
</style>